import { ReactElement } from "react";

import { MunicipalPropertyConsumptionForm } from "@/domain/municipal-property/components/municipal-property-consumption-form";

import { useMunicipalPropertyYearPageContext } from "./use-municipal-property-year-page-context";

export const MunicipalPropertyYearDataPage = (): ReactElement => (
  <MunicipalPropertyConsumptionForm {...useMunicipalPropertyYearPageContext()} />
);
